class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.scrollThreshold = parseInt(this.dataset.scrollThreshold) || 80;
    this.isVisible = false;
    this.observer = null;
    this.sentinelElement = null;
  }

  connectedCallback() {
    this.button = this.querySelector('.scroll-to-top-button');

    this.setupSentinel();
    this.setupIntersectionObserver();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.sentinelElement && this.sentinelElement.parentNode) {
      this.sentinelElement.parentNode.removeChild(this.sentinelElement);
    }
  }

  setupSentinel() {
    this.sentinelElement = document.createElement('div');
    this.sentinelElement.style.position = 'absolute';
    this.sentinelElement.style.top = this.scrollThreshold + '%';
    this.sentinelElement.style.height = '1px';
    this.sentinelElement.style.width = '1px';
    this.sentinelElement.style.display = 'block';
    this.sentinelElement.classList.add('btt-sentinal');
    this.sentinelElement.style.opacity = '0';
    this.sentinelElement.style.pointerEvents = 'none';
    document.body.appendChild(this.sentinelElement);
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !this.isVisible) {
          this.showButton();
        } else if (entry.isIntersecting && this.isVisible) {
          this.hideButton();
        }
      });
    }, options);

    this.observer.observe(this.sentinelElement);
  }

  setupEventListeners() {
    this.button.addEventListener('click', () => {
      this.scrollToTop();
    });
  }

  showButton() {
    this.isVisible = true;
    this.classList.add('visible');
  }

  hideButton() {
    this.isVisible = false;
    this.classList.remove('visible');
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
if (!customElements.get('scroll-to-top')) {
  customElements.define('scroll-to-top', ScrollToTop);
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyATC extends ScrollToTop {
      constructor() {
        super();
        this.title_el = this.querySelector('.sticky-atc__title');

        if (!this.title_el) return;

        document.body.addEventListener(
          'variantChange',
          this.setupVariantChangeListener.bind(this),
        );
      }
      setupVariantChangeListener(e) {
        var currentVariant = e.detail.currentVariant;

        this.title_el.innerText = currentVariant.name;
      }
    },
  );
}
